export default __webpack_public_path__ + "static/media/step 3.bde86a2e.png";